import { isMobile } from '../../service/deviceDetectService'
const isApplyCustomLayout =  !!APP_CONFIG.isApplyCustomLayout && !isMobile()
const isCustomLayoutBgLight =  !!APP_CONFIG.isCustomLayoutBgLight && !isMobile()

export {isApplyCustomLayout, isCustomLayoutBgLight}



// WEBPACK FOOTER //
// ./src/common/custom-layout/const.js